import { useMutation, useQueryClient } from '@tanstack/react-query';
import { setTestMode } from '../services/waterfallService';
import { SetWaterfallTestModeViewModel, WaterfallViewModel } from '../models/waterfall';

export const useWaterfallTestMode = (waterfallId?: number) => {
  const queryClient = useQueryClient();

  const setTestModeMutation = useMutation({
    mutationFn: (payload: SetWaterfallTestModeViewModel) => setTestMode(waterfallId!, payload),
    onSuccess: (updated) => {
      // Apply the new test-mode state to the cached detail synchronously so the
      // waterfall prop is not stale between the mutation and the background refetch.
      // Merge rather than replace to preserve fields the test-mode response omits
      // (e.g. versions, currentVersion).
      queryClient.setQueryData<WaterfallViewModel>(['waterfall', waterfallId], (previous) =>
        previous
          ? {
              ...previous,
              isTestMode: updated.isTestMode,
              testCaseSelections: updated.testCaseSelections,
              upgradeTestCaseSelections: updated.upgradeTestCaseSelections,
              refreshTestCaseSelections: updated.refreshTestCaseSelections,
            }
          : updated,
      );
      queryClient.invalidateQueries({ queryKey: ['waterfalls'] });
    },
  });

  return {
    setTestMode: setTestModeMutation.mutateAsync,
    isSettingTestMode: setTestModeMutation.isPending,
  };
};
